// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {useStoreInfo} from '../../modules/store/utils';
import {FREE_TRIAL_TIERS} from '../../entities';
import {useCurrentSubscription} from '../../modules/tiers/utils';
import {Tooltip, Typography, makeStyles} from '@material-ui/core';

import {getStringDate} from '../../utils/date';
import {InfoOutlined} from '@material-ui/icons';
import whiteCrown from '../../assets/img/dashboard/whiteCrown.svg';
import {colors} from '../../assets/styles/colors';

import type {Theme} from '@material-ui/core';
type Props = {};

const useStyles = makeStyles((theme: Theme) => ({
  freeTrialBanner: {
    margin: theme.spacing(2, 4, 0, 4),
    // width: '100%',
    // height: 72,
    borderRadius: '8px',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
    padding: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-around',
    },
    overflow: 'visible',
    color: colors.purple5,
    background: '#F9CE57',
  },
  whiteCrownIconBackground: {
    height: 20,
    width: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: colors.purple3,
    marginRight: theme.spacing(1),
  },
  freeTrialBannerTooltip: {
    borderRadius: '6px',
    background: colors.grey300,
    color: colors.grey800,
  },
}));
function FreeTrialBanner(props: Props) {
  const store = useStoreInfo();
  const subscription = useCurrentSubscription();

  const classes = useStyles();

  if (!store || !subscription) return null;

  const subscriptioEndDate = subscription && subscription.endDate;
  const isInFreeTrial = FREE_TRIAL_TIERS.includes(store.storeTier.name);

  if (!isInFreeTrial) return null;

  return (
    <div className={classes.freeTrialBanner}>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div className={classes.whiteCrownIconBackground}>
          <img src={whiteCrown} alt="" />
        </div>
        <Typography style={{fontWeight: 600}}>Periodo de prueba</Typography>
        <Typography
          style={{
            marginLeft: 24,
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        >
          {typeof subscriptioEndDate === 'number' &&
            `Válido hasta ${getStringDate(subscriptioEndDate)}`}
        </Typography>
      </div>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Link style={{margin: '0px 16px', fontWeight: 600}} to="/profile">
          Ver plan
        </Link>
        <Tooltip
          classes={{
            tooltip: classes.freeTrialBannerTooltip,
          }}
          title="Tu nuevo plan empezará cuando termine tu periodo gratis."
          placement="right-start"
        >
          <InfoOutlined />
        </Tooltip>
      </div>
    </div>
  );
}

export default FreeTrialBanner;
